var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25476 10.717H2.77708L2.12589 11.6051H6.01592H9.90595L9.25476 10.717Z",
    fill: "#A046D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.349776 7.35966C-0.0619564 7.91798 -0.113423 8.66241 0.212532 9.27148C0.538487 9.88056 1.17324 10.2697 1.87662 10.2697H3.90097V7.35966L3.59217 7.78263L2.42559 9.38992H1.87662C1.4992 9.38992 1.1904 9.20381 1.01884 8.86543C0.847286 8.54398 0.881597 8.17176 1.08746 7.86723L4.79306 2.75776V4.44964V6.12459V10.2697H5.68514V6.41221V0L0.349776 7.35966Z",
    fill: "#A046D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6557 7.35299L6.2999 0V6.4064V10.2604H7.2097V6.11904V4.4456V2.75526L10.9176 7.86009C11.1407 8.14745 11.1579 8.51933 10.9862 8.85739C10.8146 9.17856 10.4884 9.3814 10.1279 9.3814H9.57861L8.10233 7.36989V10.2773H10.1279C10.8317 10.2773 11.4669 9.8885 11.793 9.27998C12.1192 8.63765 12.0505 7.9108 11.6557 7.35299Z",
    fill: "#A046D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.4f8e0b49184d79be5102f4a3ec430834.svg";
export { ForwardRef as ReactComponent };